module.exports = require('./helpers/bundle-url').getBundleURL('jKRPl') + "mailgun-logo.ab2e3762.png";